import React, { useEffect } from 'react';
import Header from '../../../headerone/Main';
import Bredcom from '../../../Bredcom/Main';
import IDCardsDetails from '../../subdepartmentdetails/IDCards';

function IDCards() {
  useEffect(() => {
    document.getElementById("title").innerHTML = "State Identification Cards || Motor Vehicles";
  }, []);

  return (
    <>
      {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

      <div className="page-wrapper">
        <Bredcom 
          subtitle="Motor Vehicles"
          title="State Identification Cards"
          subtitledown="Department of Motor Vehicles"
        />
        <IDCardsDetails />
      </div>
    </>
  );
}

export default IDCards;
